import Vue from 'vue';

export default Vue.component('ed-portal-info-section-title', {
  props: ['isCollapsed', 'collapsed'],
  data: () => {
    return {
      form: [],
      sectionId: null,
      editionMode: false
    }
  },
  created() {
  },
  methods: {
    toggleCollapsed() {
      this.$emit('isCollapsed');
    }
  }
});


